export default __webpack_public_path__ + "static/media/viktor-larionov.d07f28eb.jpg";